import React from 'react';
import PropTypes from 'prop-types';
import { TextDense, Box, Spacer } from '@directsoftware/ui-kit-web-admin';
import { useSelector } from 'react-redux';
import GoogleMapReact from 'google-map-react';
import ListingsDetailsContentBlock from '../../listing/shared-v2/listings-details-content-block';
import { buildAddress } from '../../listings/resources/shared-functions';
import { selectReceiptState } from '../../../redux/slices/receipt';
import MapMarker from '../../listing/map-marker';

const DeliveryLocationMap = ({ shortMap, locationState, mapOnly }) => {
  const brand = useSelector(state => state.brand);
  const receiptState = useSelector(selectReceiptState);
  const bootstrapURLKeys = brand.google_maps_api_key
    ? { key: brand.google_maps_api_key }
    : {};
  const location = locationState || receiptState.delivery_location;
  if (!location) return null;
  const latitude = Number(location.geo_latitude);
  const longitude = Number(location.geo_longitude);
  if (mapOnly) {
    if (
      location.geo_latitude == null ||
      location.geo_longitude == null ||
      !Number.isFinite(latitude) ||
      !Number.isFinite(longitude) ||
      (!latitude && !longitude)
    )
      return null;
    return (
      <Box className="receiptRedesign__map">
        <GoogleMapReact
          bootstrapURLKeys={bootstrapURLKeys}
          center={[latitude, longitude]}
          zoom={12}
          options={{
            gestureHandling: 'greedy',
            mapTypeControl: false,
            panControl: false,
            scrollwheel: false
          }}
          resetBoundsOnResize={false}
          onChange={() => {}}
        >
          <MapMarker lat={latitude} lng={longitude} />
        </GoogleMapReact>
      </Box>
    );
  }

  return (
    <ListingsDetailsContentBlock label="Delivery Location">
      <TextDense>
        {buildAddress(receiptState.delivery_location, true)}
      </TextDense>
      <Spacer />
      <Box style={shortMap ? { height: '25vh' } : { height: '50vh' }}>
        <GoogleMapReact
          bootstrapURLKeys={bootstrapURLKeys}
          center={[
            receiptState.delivery_location.geo_latitude,
            receiptState.delivery_location.geo_longitude
          ]}
          zoom={12}
          options={{
            gestureHandling: 'greedy',
            mapTypeControl: false,
            panControl: false,
            scrollwheel: false
          }}
          resetBoundsOnResize={false}
          onChange={() => {}}
        >
          <MapMarker
            lat={receiptState.delivery_location.geo_latitude}
            lng={receiptState.delivery_location.geo_longitude}
          />
        </GoogleMapReact>
      </Box>
    </ListingsDetailsContentBlock>
  );
};

DeliveryLocationMap.propTypes = {
  shortMap: PropTypes.bool,
  locationState: PropTypes.object,
  mapOnly: PropTypes.bool
};
DeliveryLocationMap.defaultProps = {
  shortMap: false,
  locationState: null,
  mapOnly: false
};

export default DeliveryLocationMap;
